import '../app.styl'

export const colors = {
  primary       : '#008AA9',
  secondary     : '#006880',
  tertiary      : '#758595',
  accent        : '#f58220',
  error         : '#f41212',
  info          : '#12C3F4',
  success       : '#A3D183',
  warning       : '#F4CA6D',
  formInnerText : '#86898d',
  green         : '#02AC43'
}
